(() => {
  const initialize = () => {
    document.querySelectorAll('.header__inline-menu .bb-catalog-details').forEach(details => {
      if (details.dataset.bbCatalogReady) return;
      details.dataset.bbCatalogReady = 'true';
      const summary = details.querySelector('summary');
      const panel = summary.nextElementSibling;
      const fit = () => {
        if (!details.open || !window.matchMedia('(min-width: 990px)').matches) return;
        const anchor = details.getBoundingClientRect();
        const width = Math.min(780, document.documentElement.clientWidth - 32);
        const left = Math.max(16, Math.min(anchor.left, document.documentElement.clientWidth - width - 16));
        panel.style.setProperty('--bb-catalog-left', `${left - anchor.left}px`);
        panel.style.setProperty('--bb-catalog-height', `${Math.max(40, window.innerHeight - anchor.bottom - 16)}px`);
      };
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        fit();
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      });
      document.addEventListener('pointerdown', event => {
        if (details.open && !details.contains(event.target)) {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }
      });
      window.addEventListener('resize', fit);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
